import Axios from 'axios';
import queryString from '../../../helpers/queryString';
import { toastr } from 'react-redux-toastr';
import handleErrorResponse from '../../../helpers/handleErrorResponse';

const IS_LOADING = 'socrates-online/scheme/IS_LOADING';
const SET_DOCUMENT_LIST = 'socrates-online/scheme/SET_DOCUMENT_LIST';
const SET_DOCUMENT_SUMMARY_LIST = 'socrates-online/scheme/SET_DOCUMENT_SUMMARY_LIST';
const SET_DOCUMENT_INSURER_SCHEME_LIST =
  'socrates-online/scheme/SET_DOCUMENT_INSURER_SCHEME_LIST';
const VIEW_DOCUMENT = 'socrates-online/scheme/VIEW_DOCUMENT';
const EDIT_DOCUMENT = 'socrates-online/scheme/EDIT_DOCUMENT';
const CLOSE_VIEW_DOCUMENT_MODAL = 'socrates-online/scheme/CLOSE_VIEW_DOCUMENT_MODAL';
const CLOSE_EDIT_DOCUMENT_MODAL = 'socrates-online/scheme/CLOSE_EDIT_DOCUMENT_MODAL';
const CLEAR_DOCUMENT_MANAGEMENT_DATA =
  'socrates-online/scheme/CLEAR_DOCUMENT_MANAGEMENT_DATA';
const SET_DYNAMIC_DOCUMENTS_LIST = 'socrates-online/scheme/SET_DYNAMIC_DOCUMENTS_LIST';
const SET_ANCILLARY_SCHEME_DOCUMENT_LIST =
  'socrates-online/scheme/SET_ANCILLARY_SCHEME_DOCUMENT_LIST';
const CLEAR_DYNAMIC_DOCUMENT_DATA = 'socrates-online/scheme/CLEAR_DYNAMIC_DOCUMENT_DATA';
const IS_SUBMITTING = 'socrates-online/scheme/IS_SUBMITTING';
const IS_RETRIEVING_DOCUMENTS = 'socrates-online/scheme/IS_RETRIEVING_DOCUMENTS';
const IS_RETRIEVING_DOCUMENT_TYPES =
  'socrates-online/scheme/IS_RETRIEVING_DOCUMENT_TYPES';
const IS_UPDATING_DOCUMENT = 'socrates-online/scheme/IS_UPDATING_DOCUMENT';
const SET_ANCILLARY_SCHEME_DOCUMENT_TYPE =
  'socrates-online/scheme/SET_ANCILLARY_SCHEME_DOCUMENT_TYPE';
const GENERATING_NEW_DOCUMENT_VERSION =
  'socrates-online/scheme/GENERATING_NEW_DOCUMENT_VERSION';

export const SET_PRODUCT_DOCUMENT_TYPE_LIST =
  'socrates-online/scheme/SET_PRODUCT_DOCUMENT_TYPE_LIST';
export const SETUP_STATIC_DOCUMENT_COMPONENT_SUCCESS =
  'socrates-online/scheme/SETUP_STATIC_DOCUMENT_COMPONENT_SUCCESS';
export const SETUP_STATIC_DOCUMENT_COMPONENT_FAILURE =
  'socrates-online/scheme/SETUP_STATIC_DOCUMENT_COMPONENT_FAILURE';

export const SORT_SCHEMES_BY_INSURER = 'socrates-online/scheme/SORT_SCHEMES_BY_INSURER';

export const initialState = {
  isLoading: false,
  isSubmitting: false,
  isRetrievingDocuments: false,
  isRetrievingDocumentTypes: false,
  isUpdatingDocument: {
    status: false,
    id: null,
  },
  isSettingUpDocuments: false,
  documentTypes: [],
  showViewDocumentModal: false,
  showEditDocumentModal: false,
  activeViewDocument: null,
  activeEditDocument: null,
  schemesByInsurer: null,
  insurerList: [],
  documents: {
    documents: [],
    included: [],
  },
  summary: {},
  dynamicDocuments: {
    list: [],
  },
  ancillarySchemeDocuments: null,
  ancillarySchemeDocumentType: null,
  documentsGenerated: [],
};

export function reducer(state = initialState, action = {}) {
  let errors = null;
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.status,
      };
    case IS_SUBMITTING:
      return {
        ...state,
        isSubmitting: action.data,
      };
    case SETUP_STATIC_DOCUMENT_COMPONENT_FAILURE:
      /** WIP OBSERVABLES */
      if (typeof action.payload.config !== 'undefined') {
        const error = action.payload;

        // If we have a response and it contains an array of errors then
        // we should set that at the errors on the object.
        if (error.response && error.response.data.errors) {
          errors = error.response.data.errors.map((err) => {
            return err.detail;
          });
        }
      }
      return {
        ...state,
        isSettingUpDocumentComponent: false,
        errors,
      };
    case SETUP_STATIC_DOCUMENT_COMPONENT_SUCCESS:
      /** WIP OBSERVABLES */
      return {
        ...state,
        isSettingUpDocumentComponent: false,
      };
    case IS_RETRIEVING_DOCUMENTS:
      return {
        ...state,
        isRetrievingDocuments: action.data,
      };
    case IS_UPDATING_DOCUMENT:
      return {
        ...state,
        isUpdatingDocument: action.data,
      };
    case SET_DOCUMENT_LIST:
      return {
        ...state,
        documents: {
          documents: action.data.documents,
          included: action.data.included,
        },
      };
    case SET_DOCUMENT_SUMMARY_LIST:
      return {
        ...state,
        summary: {
          [action.data.documentTypeId]: action.data.summary,
        },
      };

    case GENERATING_NEW_DOCUMENT_VERSION:
      // const generatingDocumentsByType = state.isRetrievingDocuments?.[action.data.documentTypeId] ?? [];
      // console.log(generatingDocumentsByType);
      const existingDocuments = state.documentsGenerated ?? [];
      existingDocuments.push(action.data.documentId);
      return {
        ...state,
        documentsGenerated: existingDocuments,
      };
    case SET_DOCUMENT_INSURER_SCHEME_LIST:
      return {
        ...state,
        insurerList: action.data,
      };
    case VIEW_DOCUMENT:
      return {
        ...state,
        showViewDocumentModal: true,
        actionType: action.data.action,
        activeViewDocument: action.data.document,
      };
    case EDIT_DOCUMENT:
      return {
        ...state,
        showEditDocumentModal: true,
        actionType: action.data.action,
        activeEditDocument: action.data.document,
      };
    case SET_PRODUCT_DOCUMENT_TYPE_LIST:
      return {
        ...state,
        documentTypes: action.data,
      };
    case CLOSE_VIEW_DOCUMENT_MODAL:
      return {
        ...state,
        showViewDocumentModal: false,
        activeViewDocument: null,
      };

    case CLOSE_EDIT_DOCUMENT_MODAL:
      return {
        ...state,
        showEditDocumentModal: false,
        activeEditDocument: null,
      };

    case CLEAR_DOCUMENT_MANAGEMENT_DATA:
      return {
        ...state,
        initialState,
      };
    case SET_DYNAMIC_DOCUMENTS_LIST:
      return {
        ...state,
        dynamicDocuments: {
          ...state.dynamicDocuments,
          [action.data.productId]: {
            list: action.data.data,
          },
        },
      };
    case CLEAR_DYNAMIC_DOCUMENT_DATA:
      return {
        ...state,
        dynamicDocuments: {
          ...state.dynamicDocuments,
          list: [],
        },
      };
    case SET_ANCILLARY_SCHEME_DOCUMENT_LIST:
      return {
        ...state,
        ancillarySchemeDocuments: action.data,
      };

    case SET_ANCILLARY_SCHEME_DOCUMENT_TYPE:
      return {
        ...state,
        ancillarySchemeDocumentType: action.data,
      };
    default:
      return state;
  }
}

const isLoading = (status) => {
  return {
    type: IS_LOADING,
    status,
  };
};

const isSubmitting = (state) => ({ type: IS_SUBMITTING, data: state });

const isRetrievingDocuments = (state) => ({ type: IS_RETRIEVING_DOCUMENTS, data: state });

const isRetrievingDocumentTypes = (state) => ({
  type: IS_RETRIEVING_DOCUMENT_TYPES,
  data: state,
});

const setGeneratingNewDocument = (documentId) => ({
  type: GENERATING_NEW_DOCUMENT_VERSION,
  data: { documentId },
});

const isUpdatingDocument = (state) => ({ type: IS_UPDATING_DOCUMENT, data: state });

const setAncillarySchemeDocumentList = (values) => ({
  type: SET_ANCILLARY_SCHEME_DOCUMENT_LIST,
  data: values,
});

const getDocuments = (productId, documentType = null) => {
  const documentIncludes = [
    'supersedes',
    'channel',
    'schemes.insurer',
    'products',
    'document_type',
    'insurer',
    'superseded_by',
    'superseded_by.channel',
    'superseded_by.document_type',
    'superseded_by.insurer',
    'superseded_by.superseded_by',
    'superseded_by.supersedes',

    'supersedes.channel',
    'supersedes.document_type',
    'supersedes.insurer',
    'supersedes.superseded_by',
    'supersedes.supersedes',
  ];
  let documentTypeFilter = '';
  if (documentType) {
    documentTypeFilter = `&filter[document_type.name]=${documentType.attributes.name}`;
  }
  // &filter[base_document]=true
  return (dispatch) => {
    dispatch(isRetrievingDocuments(true));
    return Axios.get(
      `/documents/?filter[product]=${productId}&filter[version]=latest${documentTypeFilter}&page[limit]=0&include=${documentIncludes.join()}`,
    )
      .then((response) => {
        dispatch({
          type: SET_DOCUMENT_LIST,
          data: { documents: response.data.data, included: response.data.included },
        });
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      })
      .finally(() => {
        dispatch(isRetrievingDocuments(false));
      });
  };
};

const getDocument = (documentId) => {
  return (dispatch) => {
    return Axios.get(
      `/documents/${documentId}?include=schemes,channel,supersedes,ancillary_schemes,products`,
    )
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        dispatch(isLoading(false));
      });
  };
};

const setDocumentSummaryList = (documentTypeId, summary) => {
  return {
    type: SET_DOCUMENT_SUMMARY_LIST,
    data: { documentTypeId: documentTypeId, summary: summary },
  };
};

const getDocumentsByType = (productId, documentTypeId = null, insurerId) => {
  return (dispatch) => {
    dispatch(isRetrievingDocuments(true));
    dispatch(setDocumentSummaryList(documentTypeId, {}));

    const filters = [];
    if (insurerId) {
      filters.push(`filter[schemes.insurer]=${insurerId}`);
    }
    if (productId) {
      filters.push(`filter[product]=${productId}`);
    }
    return Axios.get(`/documents/document-types/${documentTypeId}/?${filters.join('&')}`)
      .then((response) => {
        dispatch(setDocumentSummaryList(documentTypeId, response.data.meta));
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      })
      .finally(() => {
        dispatch(isRetrievingDocuments(false));
      });
  };
};

const getJtcTobas = (productId, documentTypeId = null, insurerId) => {
  return (dispatch) => {
    dispatch(isRetrievingDocuments(true));
    dispatch(setDocumentSummaryList(documentTypeId, {}));

    const filters = [];
    if (insurerId) {
      filters.push(`filter[schemes.insurer]=${insurerId}`);
    }
    if (productId) {
      filters.push(`filter[product]=${productId}`);
    }
    return Axios.get(`/documents/jtc-document-types/${documentTypeId}/?${filters.join('&')}`)
      .then((response) => {
        dispatch(setDocumentSummaryList(documentTypeId, response.data.meta));
        dispatch(isLoading(false));
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      })
      .finally(() => {
        dispatch(isRetrievingDocuments(false));
      });
  };
};

const getDocumentTypes = (productId) => {
  return (dispatch) => {
    dispatch(isRetrievingDocumentTypes(true));
    dispatch(isLoading(true));
    // OLD WAY OF GETTING THE DATA
    return Axios.get(`/documents/document-types?filter[product]=${productId}`)
      .then((response) => {
        dispatch({ type: SET_PRODUCT_DOCUMENT_TYPE_LIST, data: response.data.data });
        return true;
      })
      .catch(() => {
        dispatch(isLoading(false));
      })
      .finally(() => {
        dispatch(isRetrievingDocumentTypes(false));
      });
  };
};

const getAncillaryDocumentType = () => {
  return (dispatch) => {
    return Axios.get('/ancillary-scheme-documents/document-type').then((response) => {
      dispatch({ type: SET_ANCILLARY_SCHEME_DOCUMENT_TYPE, data: response.data.data });
      return response.data.data;
    });
  };
};

const getDynamicDocuments = (productId) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(
      `/contents/?page[limit]=100&filter[template.type]=document&filter[status]=active,pending,ended&filter[product]=${productId}&include=products`,
    ).then((response) => {
      dispatch(isLoading(false));
      dispatch({
        type: SET_DYNAMIC_DOCUMENTS_LIST,
        data: {
          data: response.data.data,
          productId: productId,
        },
      });
    });
  };
};

const updateDynamicDocument = (resource, productId, includes = ['template', 'files']) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    const endpoint = 'contents/' + resource.data.id + queryString(includes);

    return Axios.patch(endpoint, resource)
      .then(() => {
        dispatch(isLoading(false));
        toastr.success('Success', 'Document has been updated');
        dispatch(clearDynamicDocuments());
        dispatch(getDynamicDocuments(productId));
        return true;
      })
      .catch((error) => {
        dispatch(isLoading(false));
        handleErrorResponse(error, 'There was an error updating your content');
      });
  };
};

const createNewDocument = (values, supersedesDocumentId) => {
  return (dispatch) => {
    dispatch(setGeneratingNewDocument(supersedesDocumentId));
    return Axios.post('documents', values)
      .then(() => {
        toastr.success('Success', 'Document has been saved');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error saving this document');
      });
  };
};

const endDocument = (id) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(`documents/${id}:end`)
      .then(() => {
        toastr.success('Success', 'Document has been ended');
        return true;
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
};
const updateDocument = (values, documentId) => {
  return (dispatch) => {
    dispatch(setGeneratingNewDocument(documentId));
    return Axios.patch('documents/' + documentId, values)
      .then(() => {
        toastr.success('Success', 'A New version has been created');
        dispatch(isSubmitting(false));
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error updating this document');
      });
  };
};

const getAncillaryDocuments = () => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get('ancillary-scheme-documents')
      .then((resp) => {
        dispatch(setAncillarySchemeDocumentList(resp.data.meta));

        return resp.data.meta;
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

const viewDocument = (action, document) => ({
  type: VIEW_DOCUMENT,
  data: { action, document },
});

const editDocument = (action, document) => ({
  type: EDIT_DOCUMENT,
  data: { action, document },
});

const closeViewDocumentModal = () => ({ type: CLOSE_VIEW_DOCUMENT_MODAL });
const closeEditDocumentModal = () => ({ type: CLOSE_EDIT_DOCUMENT_MODAL });
const clearDocumentManagementData = () => ({ type: CLEAR_DOCUMENT_MANAGEMENT_DATA });
const clearDynamicDocuments = () => ({ type: CLEAR_DYNAMIC_DOCUMENT_DATA });

export const actions = {
  closeViewDocumentModal,
  closeEditDocumentModal,
  clearDocumentManagementData,
  getDocument,
  getDocuments,
  getDocumentTypes,
  getJtcTobas,
  viewDocument,
  editDocument,
  getDynamicDocuments,
  createNewDocument,
  endDocument,
  updateDocument,
  updateDynamicDocument,
  isUpdatingDocument,
  // setUpStaticDocumentComponent,
  getAncillaryDocuments,
  getAncillaryDocumentType,
  getDocumentsByType,
};
